import { jsx as i } from "react/jsx-runtime";
import { c as f } from "react/compiler-runtime";
import { useRef as d, useState as g, useEffect as h } from "react";
const _ = {
  types: []
  // all types
}, v = (m) => {
  const e = f(6), {
    updatePlace: l
  } = m, r = d(null), [c, p] = g("");
  let o;
  e[0] !== l ? (o = () => {
    if (!google.maps)
      return;
    const t = new google.maps.places.Autocomplete(r.current, _);
    return t.addListener("place_changed", () => {
      const u = t.getPlace();
      l(u), p(u.name ?? "");
    }), () => {
      t.unbindAll(), google.maps.event.clearInstanceListeners(t);
    };
  }, e[0] = l, e[1] = o) : o = e[1];
  let s;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = [], e[2] = s) : s = e[2], h(o, s);
  let n;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = (t) => p(t.target.value), e[3] = n) : n = e[3];
  let a;
  return e[4] !== c ? (a = /* @__PURE__ */ i("input", { type: "text", id: "pac-input", className: "controls autoCompleteInput", placeholder: "Enter a location", value: c, ref: r, onChange: n }), e[4] = c, e[5] = a) : a = e[5], a;
};
export {
  v as default
};
